/* Décommenter la ligne si dessous pour activer UNISON */
// var allBreakpoints = Unison.fetch.all();

// Datalayer
window.dataLayer = window.dataLayer || [];

var mc = {}, // declare mc namespace
	windowHeight, windowWidth;

mc.getWindowSize = function() {
	windowHeight = $(window).height();
	$('html').css('overflow-y','hidden');
	withoutScroll = $(window).width();
	$('html').css('overflow-y','auto');
	withScroll = $(window).width();
	scroll = withoutScroll-withScroll;
	windowWidth = $(window).width()+scroll;
};

/**
 * Google Map
 */
var cmsLat      = $('#map-container').attr('data-lat');
var cmsLng      = $('#map-container').attr('data-lng');
var defaultZoom = $('#map-container').attr('data-zoom');


var GoogleMap = function() {

	var stylez = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#A8DFE6"
            },
            {
                "visibility": "on"
            }
        ]
    }
];


	simpleMap = new GMaps( {
		div:              '#map-container',
		lat:              cmsLat,
		lng:              cmsLng,
		zoom:             parseFloat(defaultZoom),
		disableDefaultUI: false,
		scrollwheel:      false,
		styles:           stylez
		// styles:           [{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"},{"color":"#052366"},{"saturation":"-70"},{"lightness":"85"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45},{"visibility":"on"}]},{"featureType":"road","elementType":"geometry","stylers":[{"saturation":"-18"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#57677a"},{"visibility":"on"}]}]
	});

	var image = new google.maps.MarkerImage('/images/pointer.png', null, null, null, new google.maps.Size(24,38));
	
	if( $("#map-container").length > 0 ){
		simpleMap.addMarker({
			lat:  cmsLat,
			lng:  cmsLng,
			icon: image
		});
	}
};


/*
      ##    #######   ##     ##  ########   ########   ##    ##   
      ##   ##     ##  ##     ##  ##         ##     ##   ##  ##    
      ##   ##     ##  ##     ##  ##         ##     ##    ####     
      ##   ##     ##  ##     ##  ######     ########      ##      
##    ##   ##  ## ##  ##     ##  ##         ##   ##       ##      
##    ##   ##    ##   ##     ##  ##         ##    ##      ##      
 ######     ##### ##   #######   ########   ##     ##     ##      
*/
$(document).imagesLoaded(function() {
	$(document).ready(function() {

		// Prepare layout options.
		var options = {
			autoResize: true,
			// itemWidth: 320,
			itemWidth: 400,
			flexibleWidth: '100%',
			offset: 20,
			align: 'left'
		};

		// Get a reference to your grid items.
		var handler = $('.masonery');

		// Call the layout function.
		handler.wookmark(options);
	});
});


$(document).ready(function() {

	// FastClick.attach(document.body);

	$('iframe').wrap("<div class='iframe'></div>")
	$(".editor-text").fitVids();

	/**
	 * Test si les Media Queries sont supportées
	 * Ajoute la classe 'mq' au tag HTML si c'est le cas
	 */
	if ( Modernizr.mq('only all') ) {
		jQuery('html').addClass('mq');
	} else {
		jQuery('html').addClass('no-mq');
	}

	/**
	 * Browser detect : masquage de la bannière
	 */
	$('.browserdetect__close').click(function(e) {
		e.preventDefault();
		$('.browserdetect').addClass('browserdetect--hidden');
	});

	/**
	 * MatchHeight [GRID]
	 */
	$(".harmonize").matchHeight();

	/**
	 * Lien sur balise quelconque (avec attribut data-link)
	 */
	$('[data-link]').click(function() {
		window.location.href = $(this).attr('data-link');
	}).find('a').click(function(e) {
		e.stopPropagation();
	});

	$('[data-link-blank]').click(function() {
		window.open($(this).attr('data-link-blank'),'_blank');
	}).find('a').click(function(e) {
		e.stopPropagation();
	});

	/**
	 * Lancement des vidéos youtube via Magnific Popup
	 */
	
	$('.btn__iframe').magnificPopup({
		type: 'iframe'
	});

	$('.btn__popup').magnificPopup({
		type: 'image',
		gallery: {
			enabled: true
		}
	});

	$('.btn__plan').magnificPopup({
		type: 'inline'
	});


	var selectTable = [];
	$('.select-once').each(function(){
		var placeholder = $(this).data('placeholder');
		selectTable[ $(this).attr('id') ] = $(this).multipleSelect({
			placeholder: placeholder,
			single: true,
			maxHeight: 300,
			onClick: function(view) {
				view.parent.removeClass('validate[required]');
				$('option[value="'+view.value+'"]', view.parent.prev('select')).attr('selected','selected');
				view.parent.closest('li').removeClass('error');
            }
		});

	});

	$('.nav-quicklink--modal').magnificPopup({
		type:'inline'
	}).click(function(){
		if( $(this).data('lot') ){
			$('#quickmeet input[name="~lot"]').val( $(this).data('lot') );
			$('#quickmeet .meet-lot-number').html( $(this).data('num') );
		}
	});

	/**
	 * SHARE
	 */
	$('.share__link--facebook').click(function(e) {
		e.preventDefault();
		var share_url = $(this).attr('data-url');
		var facebook_url = 'https://www.facebook.com/sharer/sharer.php?u=' + share_url;
		window.open(facebook_url, 'facebook_share', 'height=320, width=640, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');
	});

	$('.share__link--twitter').click(function(e) {
		e.preventDefault();
		var share_url = $(this).attr('data-url');
		var tweet_url = 'https://twitter.com/share?url=' + share_url;
		window.open(tweet_url, 'twitter_share', 'height=320, width=640, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');
	});

	$('.share__link--google').click(function(e) {
		e.preventDefault();
		var share_url = $(this).attr('data-url');
		var goog_url = 'https://plus.google.com/share?url=' + share_url;
		window.open(goog_url, 'google_share', 'height=320, width=640, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');
	});

    $('.share__link--linkedin').click(function(e) {
        e.preventDefault();
        var share_url = $(this).attr('data-url');
        var linkedin_url = 'http://www.linkedin.com/shareArticle?url=' + share_url;
        window.open(linkedin_url, 'linkedin_share', 'height=320, width=640, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');
    });

	$('.nav-quicklink--newsletter').click(function(e) {
		e.preventDefault();

		var page = $(this).attr('href'); // Page cible
		var speed = 750; // Durée de l'animation (en ms)
		$('html, body').animate( { scrollTop: $(page).offset().top }, speed ); // Go
		$('.footer-main__newsletter').addClass('footer-main__newsletter--active');
		return false;
	});

	/**
	 * Gestion de l'élément de formulaire ayant le focus
	 */
	$('.form__input input, .form__input textarea').focus(function(){
		$(this).parent().addClass('current');
	}).blur(function() {
		$(this).parent().removeClass('current');
	}); 
	
	/**
	 * Selectric
	 */

	$('.select-multiple').each(function(){
		var placeholder = $(this).data('placeholder');
		var selectAll = $(this).data('selectall');
		$(this).multipleSelect({
			placeholder:        placeholder,
			selectAllText:      "Tout sélectionner",
			allSelected:        selectAll,
			selectAllDelimiter: ['',''],
			countSelected:      "# sur % sélectionnés",
			maxHeight: 300,
			onClick: function(view) {
				view.parent.removeClass('validate[required]');
				$('option[value="'+view.value+'"]', view.parent.prev('select')).attr('selected','selected');
				view.parent.closest('li').removeClass('error');
            }
		});

	});

	/** 
	 * Nav main
	 */
	$('.nav-main-open').click(function(e) {
		e.preventDefault();
		$('.nav-main').addClass('open');
		$('body').addClass('noscroll');
	});

	$('.nav-main-close').click(function(e) {
		e.preventDefault();
		$('.nav-main').removeClass('open');
		$('body').removeClass('noscroll');
	});

	var waypoints = $('#page-content').waypoint(function(direction) {
		$('.header-main').toggleClass('header-main--smaller');
	}, {
	  //offset: '25%'
	});



	/*
	########   ########    #######    ######    ########      ###     ##     ##  ##     ##  ########   
	##     ##  ##     ##  ##     ##  ##    ##   ##     ##    ## ##    ###   ###  ###   ###  ##         
	##     ##  ##     ##  ##     ##  ##         ##     ##   ##   ##   #### ####  #### ####  ##         
	########   ########   ##     ##  ##   ####  ########   ##     ##  ## ### ##  ## ### ##  ######     
	##         ##   ##    ##     ##  ##    ##   ##   ##    #########  ##     ##  ##     ##  ##         
	##         ##    ##   ##     ##  ##    ##   ##    ##   ##     ##  ##     ##  ##     ##  ##         
	##         ##     ##   #######    ######    ##     ##  ##     ##  ##     ##  ##     ##  ########   
	*/
	if( $("#map-container").length ) GoogleMap();

	/*
	 ######     #######   ##    ##   ########      ###      ######    ########   
	##    ##   ##     ##  ###   ##      ##        ## ##    ##    ##      ##      
	##         ##     ##  ####  ##      ##       ##   ##   ##            ##      
	##         ##     ##  ## ## ##      ##      ##     ##  ##            ##      
	##         ##     ##  ##  ####      ##      #########  ##            ##      
	##    ##   ##     ##  ##   ###      ##      ##     ##  ##    ##      ##      
	 ######     #######   ##    ##      ##      ##     ##   ######       ##      
	*/
	$("form").validationEngine({ 
		ignore: ':hidden:not(select)',
		scroll: false,
		showPrompts: false,
		onFieldFailure: function(_input){
			_input.closest('li').addClass('error');
		},
		onFieldSuccess: function(_input){
			_input.closest('li').removeClass('error');
		}
	});

	$(window).on('resize orientationchange', resizeHandler);
	$(window).on('load', resizeHandler);

	$('.selectricWrapper').each(function() {
		$(this).removeClass('validate[required]');
	});

	if( $("#fcontact").length > 0 ){
		$target = $("#fcontact");
		var targetOffset = $target.offset().top - $(".header-main").height();
		$('body, html').scrollTo( targetOffset, 800 );
	}

	$("#fcontact").submit(function(){
		if($("#fcontact").validationEngine('validate')){
			window.dataLayer.push({
				'event': 'Contact',
				'program_name_location': $("#contact_programme").val()
			});

			var data = $(this).serialize() + '&act=envoi';
			var div  = $(this).empty().html('<div class="form-return">envoi en cours...</div>');

			$.ajax({
				type    : "POST",
				data    : data,
				dataType: "json",
				url     : "/contact/",
				success : function(retour) {
					div.empty().append(retour.message);
				}
			});
		}
		return false;
	});

	$("form[name='fnewsletter']").submit(function(){
		if($(this).validationEngine('validate')){
			window.dataLayer.push({
				'event': 'Newsletter',
				'contact_postalcode': $("#_f_newsletter_cp").val()
			});

			var data = $(this).serialize() + '&act=newsletter';
			var div  = $(this).empty().html('<div class="form-return">envoi en cours...</div>');

			$.ajax({
				type    : "POST",
				data    : data,
				dataType: "json",
				url     : "/contact/",
				success : function(retour) {
					div.empty().append(retour.message);
					// $('.footer-main__newsletter').removeClass('footer-main__newsletter--active');
				}
			});
		}
		return false;
	});

	$("#fterrain").submit(function(){
		if($("#fterrain").validationEngine('validate')){
			window.dataLayer.push({
				'event': 'ContactTerrain',
				'location' : $("#terrain_commune").val(),
				'area' : $("#terrain_superficie").val()
			});

			var data = $(this).serialize() + '&act=terrain';
			var div  = $(this).empty().html('<div class="form-return">envoi en cours...</div>');

			$.ajax({
				type    : "POST",
				data    : data,
				dataType: "json",
				url     : "/contact/",
				success : function(retour) {
					div.empty().append(retour.message);
					//$('.footer-main__newsletter').removeClass('footer-main__newsletter--active');
				}
			});
		}
		return false;
	});

	$("#fprogramme").submit(function(){
		if($("#fprogramme").validationEngine('validate')){
			window.dataLayer.push({
				'event': 'ContactProgramme',
				'program_name' : $("#rappel_programme_nom").val(),
				'program_city' : $("#rappel_programme_ville").val(),
				'contact_type' : $("#rappel_choice").val(),
				'contact_goal' : $("#rappel_invest").val(),
				'contact_postalcode' : $("#rappel_cp").val()
			});

			var data = $(this).serialize() + '&act=rappel';
			var div  = $(this).empty().html('<div class="form-return">envoi en cours...</div>');

			$.ajax({
				type    : "POST",
				data    : data,
				dataType: "json",
				url     : "/contact/",
				success : function(retour) {
					div.empty().append('<div class="form-return">'+retour.message+'</div>');
				}
			});
		}
		return false;
	});

	$('.sidebar-col--rappel').find('.js-open-form').on('click', function(){
		$('.search__hidden').slideToggle();
		$('.sidebar-col--rappel').toggleClass('is-open');
		// $(this).hide();
	});

	$("#fQuickForm").submit(function(){
		if($("#fQuickForm").validationEngine('validate')){
			window.dataLayer.push({
				'event': 'QuickForm',
				'qf_from': $("#form__from").val(),
				'qf_title': $("#form__title").val()
			});

			var data = $(this).serialize() + '&act=quickform';
			var div  = $(this).empty().html('<div class="form-return">envoi en cours...</div>');
			$.ajax({
				type    : "POST",
				data    : data,
				dataType: "json",
				url     : "/contact/",
				success : function(retour) {
					div.empty().append('<div class="form-return">'+retour.message+'</div>');
				}
			});
		}
		return false;
	});

	mc.getWindowSize();

	if( $('body').hasClass('home') ){
		$fotoramaDiv = $('.fotorama-mega-slider').fotorama();
		heightFotoramaHome();
	}

	var fotorama;
	
	if( $('.fotorama-mega-slider').length > 0 ) {
		fotorama = $fotoramaDiv.data('fotorama');
	}

	if( $('.slider').length > 0 ) {
		$fotoramaDiv = $('.slider .fotorama').fotorama();
		fotorama = $fotoramaDiv.data('fotorama');
	}

	$('.mega-slider__arrows .prev').click(function(e) {
		e.preventDefault();
		fotorama.show('<');
	});

	$('.mega-slider__arrows .next').click(function(e) {
		e.preventDefault();
		fotorama.show('>');
	});

	$('.slider .prev').click(function(e) {
		e.preventDefault();
		fotorama.show('<');
	});

	$('.slider .next').click(function(e) {
		e.preventDefault();
		fotorama.show('>');
	});

	$('[data-link]').click(function(e) {
		var url  = ( $(this).attr('href') || $(this).attr('data-link'));
		window.location.href = url;
	}).find('a').click(function(e) {
		e.stopPropagation();
	});

	/*
	##          #######    ######    ####  ##    ##   
	##         ##     ##  ##    ##    ##   ###   ##   
	##         ##     ##  ##          ##   ####  ##   
	##         ##     ##  ##   ####   ##   ## ## ##   
	##         ##     ##  ##    ##    ##   ##  ####   
	##         ##     ##  ##    ##    ##   ##   ###   
	########    #######    ######    ####  ##    ##   
	*/

	$('.popup-with-form').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: '#name',
		callbacks: {
			beforeOpen: function() {
				$("body").addClass('noscroll');
				$(document).bind('touchmove', function(e) {
					e.preventDefault();
				});
			},
			beforeClose: function() {
				$("body").removeClass('noscroll');
				$(document).unbind('touchmove');
			}
		}
	});

	$("#formLogin").submit(function(){
		if($("#formLogin").validationEngine('validate')){
			var data = $(this).serialize() + '&act=login';
			var div  = $(this).find('.form-retour').show().removeClass('form-error').empty().html('connexion en cours...');

			$.ajax({
				type    : "POST",
				data    : data,
				url     : "/login/",
				success : function(retour) {
					try {
				        var data = JSON.parse(retour);
				    	if( data.error ) div.addClass('form-error').html(data.error);
				    	if( data.redirect ) window.location = data.redirect;
				    } catch (e) {
				        return false;
				    }
				}
			});
		}
		return false;
	});

	$("#formLoginClient").submit(function(){
		if($("#formLoginClient").validationEngine('validate')){
			var data = $(this).serialize() + '&act=login';
			var div  = $(this).find('.form-retour').show().removeClass('form-error').empty().html('connexion en cours...');

			$.ajax({
				type    : "POST",
				data    : data,
				url     : "/login-client/",
				success : function(retour) {
					try {
						var data = JSON.parse(retour);
						if( data.error ) div.addClass('form-error').html(data.error);
						if( data.redirect ) window.location = data.redirect;
					} catch (e) {
						return false;
					}
				}
			});
		}
		return false;
	});

	/*
	 ######     #######    #######   ##    ##   ####  ########   
	##    ##   ##     ##  ##     ##  ##   ##     ##   ##         
	##         ##     ##  ##     ##  ##  ##      ##   ##         
	##         ##     ##  ##     ##  #####       ##   ######     
	##         ##     ##  ##     ##  ##  ##      ##   ##         
	##    ##   ##     ##  ##     ##  ##   ##     ##   ##         
	 ######     #######    #######   ##    ##   ####  ########   
	*/


	/*
	 ######    ####  ##     ##  ##     ##  ##            ###     ########   ########   ##     ##  ########   
	##    ##    ##   ###   ###  ##     ##  ##           ## ##       ##      ##         ##     ##  ##     ##  
	##          ##   #### ####  ##     ##  ##          ##   ##      ##      ##         ##     ##  ##     ##  
	 ######     ##   ## ### ##  ##     ##  ##         ##     ##     ##      ######     ##     ##  ########   
	      ##    ##   ##     ##  ##     ##  ##         #########     ##      ##         ##     ##  ##   ##    
	##    ##    ##   ##     ##  ##     ##  ##         ##     ##     ##      ##         ##     ##  ##    ##   
	 ######    ####  ##     ##   #######   ########   ##     ##     ##      ########    #######   ##     ##  
	*/

	if( $(".editor-text--simulateur").length > 0 ){

		if( !$.cookie( 'form-simulateur' ) ){

			var iframe = $(this).find('.iframe').hide();

			$("#fSimulateur").submit(function(){
				if($("#fSimulateur").validationEngine('validate')){
					var data = $(this).serialize() + '&act=calculette';
					// var div  = $(this).find('.form-retour').show().removeClass('form-error').empty().html('Envoi en cours...');
					$.ajax({
						type    : "POST",
						data    : data,
						url     : "/contact/",
						success : function(retour) {
							try {
						        var data = JSON.parse(retour);
						    	if( data.error ){ 
						    		div.addClass('form-error').html(data.error);
						    		return false;
						    	}
						    	$.cookie( 'form-simulateur', 1, { expires: 31, path: '/'});
						    	$('#fSimulateur').hide();
						    	iframe.show();
						    } catch (e) {
						    	$.removeCookie ('form-simulateur');
						    }
						}
					});
				}
				return false;
			});

		}else{
			$("#fSimulateur").hide();
		}

	}

});

var heightFotoramaHome = function(){
	var fotorama = $fotoramaDiv.data('fotorama');
	$('.fotorama-mega-slider').on('fotorama:ready ' + 'fotorama:show ' + 'fotorama:load ', function () {
	        var newHeight = $(".mega-slider__content").height();       
	        fotorama.resize({
	            height: newHeight
	        });
	    }).fotorama();
};

var sticky = false;

stickyForm = function(){

	if( $('.programme-data--rappel').length > 0 ){

		if( $(window).width() > 1023 && ! Modernizr.touch ){

			sticky = new Waypoint.Sticky({
				element: $('.programme-data--rappel')[0],
				offset: 140
			});

		}else{

			if( sticky ) sticky.destroy();
			sticky = false;

		}

	}
};

// $(window).on("resize", function(){
// 	mc.getWindowSize();
// 	if( $('body').hasClass('home') ){ heightFotoramaHome(); }
// });

var resizeHandler = function() {
	mc.getWindowSize();
	if( $('body').hasClass('home') ){ heightFotoramaHome(); }
	stickyForm();
};

var debounce = function( wait, immediate, func ) {
	var timeout;

	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

var addEndEvent = debounce( 200, false, function(e) {
	jQuery(this).trigger(e.type + 'End');
});
